export enum StoriesRoots {
    Buttons = 'Buttons',
    Feedback = 'Feedback',
    Forms = 'Forms',
    DataDisplay = 'Data display',
    GettingStarted = 'Getting started',
    Navigation = 'Navigation',
    Layout = 'Layout',
    Media = 'Media',
    Other = 'Other',
    Helpers = 'Helpers',
}

export enum StorybookGroups {
    Avatar = `${StoriesRoots.Media}/Avatar`,
    Background = `${StoriesRoots.Media}/Background`,
    Banner = `${StoriesRoots.Feedback}/Banner`,
    Buttons = `${StoriesRoots.Buttons}`,
    Card = `${StoriesRoots.Layout}/Card`,
    Checkbox = `${StoriesRoots.Forms}/Checkbox`,
    DataDisplay = `${StoriesRoots.DataDisplay}`,
    Date = `${StoriesRoots.Forms}/Date pickers`,
    Dropdown = `${StoriesRoots.Forms}/Dropdown`,
    Expandable = `${StoriesRoots.Helpers}/Expandable`,
    Feedback = `${StoriesRoots.Feedback}`,
    Forms = StoriesRoots.Forms,
    GettingStarted = StoriesRoots.GettingStarted,
    Helpers = StoriesRoots.Helpers,
    Icon = `${StoriesRoots.Media}/Icon`,
    Image = `${StoriesRoots.Media}/Image`,
    Input = `${StoriesRoots.Forms}/Input`,
    Layout = `${StoriesRoots.Layout}`,
    List = `${StoriesRoots.DataDisplay}/List`,
    Loaders = `${StoriesRoots.Feedback}/Loaders`,
    Media = StoriesRoots.Media,
    Navigation = StoriesRoots.Navigation,
    Notification = `${StoriesRoots.Feedback}/Notification`,
    Placeholder = `${StoriesRoots.Media}/Placeholder`,
    Progress = `${StoriesRoots.Feedback}/Progress`,
    Select = `${StoriesRoots.Forms}/Select`,
    Switch = `${StoriesRoots.Forms}/Switch`,
    Tab = `${StoriesRoots.DataDisplay}/Tab`,
    Tag = `${StoriesRoots.Feedback}/Tag`,
    Text = `${StoriesRoots.Other}/Text`,
    Textarea = `${StoriesRoots.Forms}/Textarea`,
    Time = `${StoriesRoots.Forms}/Time pickers`,
    Other = `${StoriesRoots.Other}`,
}

export const STORYBOOK_ROOTS_ORDER = [
    StoriesRoots.GettingStarted,
    StoriesRoots.Buttons,
    StoriesRoots.Feedback,
    StoriesRoots.Forms,
    StoriesRoots.DataDisplay,
    StoriesRoots.Navigation,
    StoriesRoots.Layout,
    StoriesRoots.Media,
    StoriesRoots.Other,
    StoriesRoots.Helpers,
] as const;

export type ComponentStoryTitle<Group extends StorybookGroups> = `${Group}/${string}`;
